<template>
  <v-menu
    offset-y
    origin="center center"
    class="elelvation-1"
    :nudge-bottom="14"
    transition="scale-transition"
    max-height="500px"
    :min-width="!isMobile ? '800px' : '100%'"
    :close-on-content-click="false"
  >
    <v-btn slot="activator" icon flat>
      <v-badge color="red" overlap>
        <span v-if="badge" slot="badge">{{ badge }}</span>
        <v-icon medium> build </v-icon>
      </v-badge>
    </v-btn>
    <v-card class="elevation-0">
      <v-toolbar card dense color="transparent">
        <v-toolbar-title>
          <span class="grey--text text--darken-1 body-2">{{
            $tc('models.notification', 2)
          }}</span>
        </v-toolbar-title>
        <v-spacer />
        <v-btn
          v-if="notifications.length"
          flat
          color="primary"
          class="caption"
          small
          :loading="indexLoading == 'all'"
          @click="_readAll()"
        >
          <v-icon class="mr-1"> check </v-icon>
          <span class="caption">{{ $t('action.buttons.markRead') }}</span>
        </v-btn>
        <v-btn icon flat color="primary" @click="init()">
          <v-icon>refresh</v-icon>
        </v-btn>
      </v-toolbar>
      <v-progress-linear
        :active="loading"
        height="3"
        :indeterminate="true"
        class="my-0"
      />
      <v-divider />
      <v-card-text class="pa-0">
        <v-list v-if="notifications.length" three-line class="pa-0">
          <template v-for="(item, index) in notifications">
            <v-divider :key="item.title + index" />
            <v-list-tile :key="item + index + 300" avatar>
              <v-list-tile-avatar v-if="item.icon" :color="item.color">
                <v-img :src="item.icon" />
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title v-html="item.title" />
                <v-list-tile-sub-title v-html="item.text" />
              </v-list-tile-content>

              <v-list-tile-action class="caption">
                <v-list-tile-action-text class="caption">
                  {{ formatDate(item.sendDate) }}
                </v-list-tile-action-text>
                <template v-if="indexLoading === index">
                  <v-progress-circular
                    size="20"
                    width="3"
                    indeterminate
                    color="primary"
                  />
                </template>
                <v-btn
                  v-else
                  icon
                  flat
                  color="primary"
                  @click="_read(item._id, index)"
                >
                  <v-tooltip left>
                    <template #activator="{ on }">
                      <v-icon
                        color="grey lighten-1"
                        class="markunread"
                        v-on="on"
                      >
                        markunread
                      </v-icon>
                    </template>
                    <span>{{ $t('action.buttons.markRead') }}</span>
                  </v-tooltip>
                </v-btn>
              </v-list-tile-action>
            </v-list-tile>
          </template>
        </v-list>
        <v-layout v-else row wrap justify-center py-3>
          <span>{{ $vuetify.t('$vuetify.dataIterator.noResultsText') }}.</span>
        </v-layout>
        <template v-if="totalPages > 1">
          <v-divider />
          <v-layout row wrap justify-center py-2>
            <v-pagination
              v-model="localPagination.page"
              :length="totalPages"
              :total-visible="totalPages > 5 ? 5 : undefined"
              color="primary"
            />
          </v-layout>
        </template>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import { debounce } from 'debounce'
import moment from 'moment'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'SupportMenu',
  data: () => ({
    indexLoading: '',
    loading: false,
  }),
  watch: {
    'localPagination.page': {
      handler: function (val, oldVal) {
        if (val != oldVal) this.debounceFetch()
      },
    },
  },
  mounted() {
    this.init()
  },
  computed: {
    ...mapState({
      notifications: (state) => state.notifications.supportList,
      supportPagination: (state) => state.notifications.supportPagination,
      badge: (state) => state.notifications.supportBadge,
    }),
    localPagination: {
      get() {
        return this.supportPagination
      },
      set(value) {
        this.$store.commit('notifications/setSupportPagination', value)
      },
    },
    totalPages() {
      const { totalItems, rowsPerPage } = this.localPagination
      if (rowsPerPage) {
        return Math.ceil(totalItems / rowsPerPage)
      } else return 1
    },
  },
  methods: {
    ...mapActions({
      fetchSupportList: 'notifications/fetchSupportList',
      read: 'notifications/read',
      readAll: 'notifications/readAll',
    }),
    _read(_id, index) {
      this.indexLoading = index
      this.read(_id).finally(() => {
        this.indexLoading = ''
        this.init()
      })
    },
    _readAll() {
      this.indexLoading = 'all'
      this.readAll({ type: 'support' }).finally(() => {
        this.indexLoading = ''
        this.init()
      })
    },
    init() {
      this.loading = true
      this.fetchSupportList().finally(() => {
        this.loading = false
        // if (!this.notifications.length && this.localPagination.page != 1) {
        //   this.localPagination.page = 1
        // }
      })
    },

    debounceFetch: debounce(function () {
      this.init()
    }, 700),
    formatDate(date) {
      return moment(date).fromNow()
    },
  },
}
</script>
<style lang="scss" scoped>
.markunread {
  &:hover {
    color: var(--v-primary-base) !important;
  }
}
</style>
